export class Faq {
  id: number;
  question: string;
  answer: string;
  groupId: number;
  createdAt: string;
  updatedAt: string;
  constructor() {
    this.id = null;
    this.question = '';
    this.answer = '';
    this.groupId = null;
    this.createdAt = '';
    this.updatedAt = '';
  }
}
